import Vue from 'vue'
import Router from 'vue-router'

import LoginView from '@/views/Login'
import CheckInView from '@/views/Checkin'
import LoadingView from '@/views/Loading'
import ErrorView from '@/views/Error'

Vue.use(Router)

const titlename = ' | RMUTL Check-In'

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '*',
      name: 'loading',
      component: LoadingView,
      meta: { title: 'Loading', title_sub: 'Loading' }
    },
    {
      path: '/login',
      name: 'login',
      component: LoginView,
      meta: { title: 'Login', title_sub: 'Login' }
    },
    {
      path: '/checkin',
      name: 'checkin',
      component: CheckInView,
      meta: { title: 'Check-In', title_sub: 'Check-In' }
    },
    {
      path: '/error',
      name: 'error',
      component: ErrorView,
      meta: { title: 'Error', title_sub: 'Error' }
    }
  ]
})
const DEFAULT_TITLE = titlename
router.afterEach((to, from) => {
  document.title = to.meta.title_sub !== '' ? to.meta.title_sub + titlename : to.meta.title + titlename || DEFAULT_TITLE + titlename
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js